import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CrudService } from "src/app/controls/base/crud-service.interface";
import { SpeedTrial } from "../models/speed-trial.interface";
import { ApiDataService } from "src/app/api/services/api-data.service";
import { StageResultBaseEntity } from "../models/stage-result-base.entity.interface";

@Injectable()
export class RadarService implements CrudService<StageResultBaseEntity> {

    /** Api data service reference */
    private service = inject(ApiDataService);

    /** @inheritdoc */
    get(id: number): Observable<StageResultBaseEntity> {
        return this.service.get<StageResultBaseEntity>('speed-trial-results/get-radar/' + id);
    }

    /** @inheritdoc */
    create(entity: StageResultBaseEntity): Observable<number> {
        return this.service.post<number>('speed-trial-results/create-radar', entity);
    }

    /** @inheritdoc */
    update(entity: StageResultBaseEntity): Observable<boolean> {
        return this.service.put<boolean>('speed-trial-results/update-radar', entity);
    }
}